/**
 * We will use this flag to toggle the error input classes
 */
export default {
  props: {
    hasErrors: {
      type: Boolean,
      default: false,
    },
  },
}
